import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from '../api';

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('bgg_admin_token');
    const username = localStorage.getItem('bgg_admin_user');
    if (token) {
      setAdmin({ token, username });
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    setLoading(false);
  }, []);

  const login = (token, username) => {
    localStorage.setItem('bgg_admin_token', token);
    localStorage.setItem('bgg_admin_user', username);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setAdmin({ token, username });
  };

  const logout = () => {
    localStorage.removeItem('bgg_admin_token');
    localStorage.removeItem('bgg_admin_user');
    delete axios.defaults.headers.common['Authorization'];
    setAdmin(null);
  };

  return (
    <AdminContext.Provider value={{ admin, login, logout, loading }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);
